import { render, staticRenderFns } from "./TaskChangeTimes.vue?vue&type=template&id=85afb75c&"
import script from "./TaskChangeTimes.vue?vue&type=script&lang=js&"
export * from "./TaskChangeTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QField,QIcon,QToggle,QSeparator,QCardActions,QBtn,QSpace} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QField,QIcon,QToggle,QSeparator,QCardActions,QBtn,QSpace}, component.options.components || {})
